/**
 * Display labels for Settings → System Information.
 * Update when upgrading major stack versions (check package.json / composer.json).
 */
export const REACT_VERSION_LABEL = '18.x';
export const LARAVEL_VERSION_LABEL = '12.x';
